import { render, staticRenderFns } from "./UpdateUserMoodle.vue?vue&type=template&id=17faf4fc"
import script from "./UpdateUserMoodle.vue?vue&type=script&lang=js"
export * from "./UpdateUserMoodle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports